import { render, staticRenderFns } from "./TemplateLibraryModal.vue?vue&type=template&id=3a0584ca&scoped=true&"
import script from "./TemplateLibraryModal.vue?vue&type=script&lang=js&"
export * from "./TemplateLibraryModal.vue?vue&type=script&lang=js&"
import style0 from "./TemplateLibraryModal.vue?vue&type=style&index=0&id=3a0584ca&prod&lang=scss&"
import style1 from "./TemplateLibraryModal.vue?vue&type=style&index=1&id=3a0584ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0584ca",
  null
  
)

export default component.exports